module.exports = __webpack_public_path__ + "img/21.6b0d4db8.svg";